import type {
  BatchAssignRanksDto,
  UpdateIdeaRankDto,
  UpdateIdeaRankResponseDto,
} from '@tempo-io/fim3-dto';
import type { AxiosInstance } from 'axios';
import { useErrorHandlingMutation } from './useErrorHandlingMutation';

export const useRanksApi = (httpClient: AxiosInstance) => {
  const baseUrl = `/ranks`;

  const _updateRank = async (updateDto: UpdateIdeaRankDto): Promise<UpdateIdeaRankResponseDto> => {
    const { data } = await httpClient.post(`${baseUrl}/update`, updateDto);

    return data;
  };

  const batchAssignRanks = async (batchParams: BatchAssignRanksDto): Promise<void> => {
    const { data } = await httpClient.post(`${baseUrl}/batchAssign`, batchParams);
    return data;
  };

  const updateRank = useErrorHandlingMutation({
    mutationFn: _updateRank,
    // onSuccess handling done by the caller to set the rank returned by the server on the idea
  });

  return { updateRank, batchAssignRanks };
};
